module.exports = __webpack_public_path__ + "img/poll.31f16a78.png";